import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

export module ContentRelayUtils {
  // Content Relay is gated by BOTH the tabhfcontentmobility_cloudenabled feature flag and the
  // per-user content-mobility capability. See SessionUserSelectors.isContentRelayEnabled.
  export const isContentRelayEnabled: () => boolean = () => {
    return getSessionManagementServiceInstance().isContentRelayEnabled();
  };
}
